import { ReactNode } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "@/state/store";
import { openPopup, closePopup } from "@/state/modal/popupSlice";

const usePopupModal = () => {
  const dispatch = useDispatch<AppDispatch>();
  const stack = useSelector((state: RootState) => state.popups.stack);

  const open = (popup: ReactNode) => {
    dispatch(openPopup(popup));
  };

  const close = () => {
    if (stack.length > 1) {
      dispatch(closePopup(stack.splice(-1)));
    } else {
      dispatch(closePopup([]));
    }
  };

  return { stack, open, close };
};

export default usePopupModal;
